import {
  RFID_ENDORSEMENTS_FAIL,
  RFID_ENDORSEMENTS_REQUEST,
  RFID_ENDORSEMENTS_SUCCESS,
  RFID_ENDORSEMENT_APPROVE_FAIL,
  RFID_ENDORSEMENT_APPROVE_REQUEST,
  RFID_ENDORSEMENT_APPROVE_SUCCESS,
} from "../constants/RfidEndorsementConstants";

const initialState = {
  cdl: [],
  subcontract: [],
  loading: false,
  approving: false,
  error: null,
};

const RfidEndorsementReducer = (state = initialState, action) => {
  switch (action.type) {
    case RFID_ENDORSEMENTS_REQUEST:
      return { ...state, loading: true, error: null };
    case RFID_ENDORSEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        cdl: action.payload.cdl,
        subcontract: action.payload.subcontract,
        error: null,
      };
    case RFID_ENDORSEMENTS_FAIL:
      return { ...state, loading: false, error: action.payload.error };
    case RFID_ENDORSEMENT_APPROVE_REQUEST:
      return { ...state, approving: true, error: null };
    case RFID_ENDORSEMENT_APPROVE_SUCCESS:
      return {
        ...state,
        approving: false,
        cdl:
          action.payload.kind === "cdl"
            ? state.cdl.filter((row) => row.HBL_ID !== action.payload.id)
            : state.cdl,
        subcontract:
          action.payload.kind === "subcontract"
            ? state.subcontract.filter(
                (row) =>
                  row.TFT_UID !== action.payload.id ||
                  row.TFT_DATETIME !== action.payload.date
              )
            : state.subcontract,
      };
    case RFID_ENDORSEMENT_APPROVE_FAIL:
      return { ...state, approving: false, error: action.payload.error };
    default:
      return state;
  }
};

export default RfidEndorsementReducer;